const config = require("../config")

module.exports = {
    //用户列表
    userList: {
        url: config.base_dev_url + "z_agricultural_store_farm/list",
        type: "get",
    },
    //农场信息
    getFarmDetail: {
        url: config.base_dev_url + "v2/farm/getFarmDetail",
        type: "get",
    },
    //根据农场ID查询农事互动列表
    getFarmWorkList: {
        url: config.base_dev_url + "work_code/phenology/quest/listByFarmId/{page}/{limit}",
        type: "get",
    },
    //获取农事记录详情列表 V2版本
    getDetailList: {
        url: config.base_dev_url + "z_farm_work_record/detail-list",
        type: "get",
    },
    //获取未来农事列表
    getFutureFarmWorkList: {
        url: config.base_dev_url + "container_farm_work_arrange/futureFarmWorkList/{page}/{limit}",
        type: "get",
    },
    //统计农场的过往农事服务成本
    getFarmPastServiceCost: {
        url: config.base_dev_url + "z_farm_work_record/statistics",
        type: "get",
    },
    //农资查询服务农场的最新广播
    getLatestBroadcast: {
        url: config.base_dev_url + "farm_broadcast/latestByServiceFarm",
        type: "post",
    },
    //查询农场当前问卷问题接口
    listWithAnswer: {
        url: config.base_dev_url + "container_farm_work_arrange/listWithAnswer",
        type: "get",
    },
    //农场服务记录
    farmServiceRecord: {
        url: config.base_dev_url + "z_farm_work_record/farmServiceRecord",
        type: "get",
    },
}